// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"WkCLp60","gigAttributeWrapper":"WkCLp60","gig-attribute":"hKtPwyt","gigAttribute":"hKtPwyt","attribute-text":"P3pdv88","attributeText":"P3pdv88"};